exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.footer-bottom {\n  display: -ms-flexbox;\n  -webkit-display: flex;\n  -moz-display: flex;\n  -ms-display: flex;\n  -o-display: flex;\n  display: flex;\n  -moz-justify-content: space-between;\n  -ms-justify-content: space-between;\n  -o-justify-content: space-between;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  margin: 0 auto;\n  width: 99%;\n  border-top: 1px solid #e1e7ee;\n  line-height: 48px;\n  padding: 0 0.3rem;\n  color: #7e8187;\n  text-align: center;\n}\n.footer .footer-bottom a {\n  margin: 0 15px;\n  color: #7e8187;\n}\n.footer .footer-bottom a:hover {\n  color: #4679f1;\n}\n.footer .footer-bottom .logo-iflytek {\n  display: inline-block;\n  margin: 0 15px;\n  width: 85px;\n  height: 48px;\n  text-indent: -10000px;\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-569dd3dc","scoped":false,"hasInlineConfig":false}!./~/postcss-loader/lib?sourceMap!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/Footer/Footer.vue
// module id = 601
// module chunks = 40